import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "typo__label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.textLabel)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.textLabel), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_multiselect, _mergeProps({
      placeholder: "",
      class: "uk-form-controls uk-text-small"
    }, _ctx.$attrs, {
      options: _ctx.options || [],
      "show-labels": false,
      "tag-placeholder": ""
    }), _createSlots({ _: 2 }, [
      _renderList(_ctx.$slots, (_, slotName) => {
        return {
          name: slotName,
          fn: _withCtx((slotProps) => [
            _renderSlot(_ctx.$slots, slotName, _normalizeProps(_guardReactiveProps(slotProps)))
          ])
        }
      })
    ]), 1040, ["options"])
  ]))
}